/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect } from 'react';

const useDebouncedEffect = (effect: () => void, deps: any[], delay = 300) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

export default useDebouncedEffect;
